<template>
  <div style="padding: 5px" class="dict">
    <div class="menu">
      <header>
        <h2>{{ $t('dict.title') }}</h2>
        <a-space>
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a => a.code === 'system:dict:query')">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" @click="visible=true; dicts=[]; title=$t('dict.addTitle')" v-if="authorities.find(a => a.code === 'system:dict:insert')">{{ $t('buttons.add') }}</a-button>
        </a-space>
      </header>
      <a-table
        :columns="columns"
        :data-source="data"
        :row-key="record => record.id"
        :pagination="pagination"
        :loading="isLoading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template v-slot:detailsName="text">
          <text-highlight :queries="[highLightInfo['details.name']]">{{text}}</text-highlight>
        </template>
        <template v-slot:code="text">
          <text-highlight :queries="[highLightInfo.code]">{{text}}</text-highlight>
        </template>
        <template v-slot:pid="text">
          {{ pids[text] }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
        <template #operation="text, record">
          <a-button type="link" style="padding-left: 0" @click="showEditModal(record)" v-if="authorities.find(a => a.code === 'system:dict:update')">{{ $t('buttons.edit') }}</a-button>
          <!-- <a-popconfirm
            title="确定要删除吗?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="removeRole(record)"
          >
            <a href="#">删除</a>
          </a-popconfirm> -->
        </template>
      </a-table>
      <a-modal v-model="visible" :title="title" :width="800" @ok="submitForm" @cancel="clearForm">
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('dict.zh-CN')">
            <a-input v-model="form['zh-CN']" />
          </a-form-model-item>
          <a-form-model-item :label="$t('dict.en-US')">
            <a-input v-model="form['en-US']" />
          </a-form-model-item>
          <a-form-model-item :label="$t('dict.code')">
            <a-input v-model="form.code" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.priority')">
            <a-input-number style="width: 100%;" v-model="form.priority" />
          </a-form-model-item>
          <a-form-model-item :label="$t('organization.enabled')">
            <a-switch v-model="form.enabled" />
          </a-form-model-item>
          <a-form-model-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
            <a-space>
              <a-button type="primary" @click="dictVisible = true">
                {{ $t('buttons.add') }}
              </a-button>
            </a-space>
            <a-table
              style="width: 100%; margin-top: 10px"
              :columns="dictColumns"
              :data-source="dicts"
              :row-key="record => record.id"
            >
              <template #operation="text, record">
                <a href="#" @click="removeContent(record)">{{ $t('buttons.delete') }}</a>
              </template>
            </a-table>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal :title="$t('dict.insert')" v-model="dictVisible" @ok="addDict" @cancel="handleCancel">
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('dict.text')">
            <a-input v-model="dictForm.text" />
          </a-form-model-item>
          <a-form-model-item :label="$t('dict.en')">
            <a-input v-model="dictForm.en" />
          </a-form-model-item>
          <a-form-model-item :label="$t('dict.value')">
            <a-input v-model="dictForm.value" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.priority')">
            <a-input-number style="width: 100%;" v-model="dictForm.priority" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  getDictList,
  searchDictList,
  addDict,
  updateDict,
  removeDict,
  getDict
} from '@/api/dict'
import {
  getRoleList,
  searchRoleList,
  addRole,
  updateRole,
  removeRole
} from '@/api/auth/role'
import TextHighlight from 'vue-text-highlight'
import { nanoid } from 'nanoid'

export default {
  components: {TextHighlight},
  data() {
    return {
      data: [],
      highLightInfo: {
        'details.name': '',
        code: ''
      },
      authorities: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      visible: false,
      isLoading: false,
      selectedRowKeys: [],
      dictVisible: false,
      dictForm: {
        text: '',
        value: '',
        priority: '',
        en: ''
      },
      dictColumns: [
        {
          title: () => this.$t('dict.text'),
          dataIndex: 'text',
          key: 'text'
        },
        {
          title: () => this.$t('dict.en'),
          dataIndex: 'en',
          key: 'en'
        },
        {
          title: () => this.$t('dict.value'),
          dataIndex: 'value',
          key: 'value',
          width: 300
        },
        {
          title: () => this.$t('menu.priority'),
          dataIndex: 'priority',
          key: 'priority'
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      dicts: [],
      columns: [
        {
          title: () => (<div>{ this.$t('dict.name') }<span class="icons unset" style="cursor: pointer;" data-index="0"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input class="search" allow-clear type="text" data-index="0" /></div>),
          dataIndex: 'zh-CN',
          key: 'details.name',
          scopedSlots: {
            customRender: 'detailsName'
          }
        },
        {
          title: () => (<div>{ this.$t('dict.typeCode') }<span class="icons unset" style="cursor: pointer;" data-index="1"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input class="search" type="text" allow-clear data-index="1" /></div>),
          dataIndex: 'code',
          key: 'code',
          scopedSlots: {
            customRender: 'code'
          }
        },
        {
          title: () => this.$t('menu.priority'),
          dataIndex: 'priority',
          key: 'priority'
        },
        {
          title: () => (<div>{ this.$t('common.createdAt') }<span class="icons unset" style="cursor: pointer; right: -52px" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 200
        },
        {
          title: () => (<div>{ this.$t('common.updatedAt') }<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 200
        },
        {
          title: () => this.$t('organization.enabled'),
          dataIndex: 'enabled',
          key: 'enabled',
          scopedSlots: {
            customRender: 'enabled'
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          width: 100
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      pids: {
        0: '无'
      },
      sortInfo: [],
      searchInfo: {
        text: {
          protocolCode: '',
          protocolName: ''
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      menus: [],
      title: this.$t('dict.addTitle'),
      form: {
        code: '',
        priority: '',
        enabled: true,
        details: [
          {
            name: '',
            locale: 'zh-CN'
          },
          {
            name: '',
            locale: 'en-US'
          }
        ],
        content: [],
        'zh-CN': '',
        'en-US': ''
      },
      scroll: {
        x: false
      }
    }
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  created() {
    this.queryParams = {
      query: [],
      filter: [],
      sort: [
        {
          field: 'updatedAt',
          value: 'DESC'
        }
      ]
    }
    this.title = this.$t('dict.addTitle')
  },
  mounted() {
    this.getDictList()
    this.$nextTick(() => {
      const ss = document.querySelectorAll('.dict .ant-table-column-title > div span.icons')
      ss.forEach(i => {
        i.addEventListener('click', () => {
          let c = ''
          switch (i.classList[1]) {
            case 'ASC':
              c = 'DESC'
              break;
            case 'DESC':
              c = 'unset'
              break;
            case 'unset':
              c = 'ASC'
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1])
          i.classList.add(c)
          const ii = document.querySelectorAll('.dict .ant-table-column-title > div span.icons:not(.unset)')
          const sort = Array.from(ii).map(item => {
            const index = +item.dataset['index']
            console.log(item.classList);
            return {
              field: this.columns[index].key,
              value: item.classList[1]
            }
          })
          this.queryParams.sort = sort
          this.searchDictList()
        })
      })
      const ips = document.querySelectorAll('.dict .search .ant-input')
      ips.forEach(ip => {
        ip.addEventListener('keyup', ({ key, target }) => {
          // console.log(key, target.value.trim())
          if (key === 'Enter') {
            target.value = target.value.trim()
            // target.value.trim() && this.handleSearch()
            this.handleSearch()
          }
        })
        ip.addEventListener('blur', ({ target }) => {
          target.value = target.value.trim()
        })
      })
    })
    const width = window.innerWidth
    if (width < 1200) {
      this.scroll.x = 1000
    } else {
      this.scroll.x = false
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    async getDictList() {
      this.searchDictList()
    },
    addDict() {
      this.dictForm.id = nanoid()
      console.log(this.dictForm);
      this.dicts.push(this.dictForm)
      this.dictVisible = false
      this.dictForm = {
        text: '',
        value: '',
        priority: '',
        en: ''
      }
    },
    handleCancel() {
      this.dictForm = {
        text: '',
        value: '',
        priority: '',
        en: ''
      }
    },
    async getMenuList() {
      let res = await getMenuList(1, 100)
      if (res.data.total > 100) {
        res = await getMenuList(1, res.data.total)
      }
      this.menus = res.data.records
    },
    handleSearch() {
      this.pagination.current = 1
      const ss = document.querySelectorAll('.dict .ant-select')
      this.queryParams.filter = []
      ss.forEach(s => {
        const vDom = s.querySelector('.dict .ant-select-selection-selected-value')
        if (vDom) {
          const index = +s.dataset['index']
          this.queryParams.filter.push({
            field: this.columns[index].key,
            value: booleanMap[vDom.innerHTML]
          })
        }
      })
      const ips = document.querySelectorAll('.dict .search .ant-input')
      this.queryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.queryParams.query.push({
            field: this.columns[+ip.dataset['index']].key,
            value: ip.value
          })
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ip.value
        } else {
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ''
        }
      })
      this.searchDictList()
    },
    async searchDictList(callback) {
      this.isLoading = true
      try {
        const { data } = await searchDictList(this.pagination.current, this.pagination.pageSize, this.queryParams)
        this.data = data.records.map(item => {
          item.details.forEach(d => {
            item[d.locale] = d.name
          })
          if (!item['zh-CN']) {
            item['zh-CN'] = item['en-US']
          }
          this.pids[item.id] = item['zh-CN']
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        if (callback) {
          this.search = true
          await callback()
          this.pagination.current = data.current
          this.pagination.total = data.total
        } else {
          this.pagination.current = data.current
          this.pagination.total = data.total
        }
      } finally {
        this.isLoading = false
      }
    },
    async handleReset(clearFilters, dataIndex) {
      clearFilters()
      this.searchInfo.text[dataIndex] = ''
      this.searchInfo.column[dataIndex] = false
      this.query.query[0].value = ''
      this.searchDictList()
    },
    async removeRole(record) {
      try {
        const { message } = await removeDict(record.id)
        this.$message.success(message)
        if(this.data.length === 1 && this.data[0].id === record.id) {
          this.pagination.current = this.pagination.current === 1 ? 1 : this.pagination.current - 1
        }
        this.searchDictList()
      } catch(e) {
        console.log(e)
        this.$message.error(this.$t('messages.ftd'))
      }
    },
    async submitForm() {
      try {
        const form = { ...this.form, content: this.dicts }
        form.details[0].name = form['zh-CN']
        form.details[1].name = form['en-US']
        delete form['zh-CN']
        delete form['en-US']
        // form.content = form.content.map(i => {
        //   return {
        //     text: i.text,
        //     value: i.value,
        //     priority: i.priority,
        //     locale: i.locale
        //   }
        // })
        const c = []
        if (this.form.id) {
          form.details[0].dictId = this.form.id
          form.details[1].dictId = this.form.id

          form.content.forEach(cc => {
            c.push({
              dictId: this.form.id,
              text: cc.text,
              value: cc.value,
              priority: cc.priority,
              locale: 'zh-CN'
            })
            c.push({
              dictId: this.form.id,
              text: cc.en,
              value: cc.value,
              priority: cc.priority,
              locale: 'en-US'
            })
          })
          form.content = c
          console.log(form);
          const { message } = await updateDict(form)
          this.$message.success(message)
        } else {
          form.content.forEach(cc => {
            c.push({
              text: cc.text,
              value: cc.value,
              priority: cc.priority,
              locale: 'zh-CN'
            })
            c.push({
              text: cc.en,
              value: cc.value,
              priority: cc.priority,
              locale: 'en-US'
            })
          })
          form.content = c
          const { message } = await addDict(form)
          this.$message.success(message)
        }
        this.searchDictList()
        this.visible = false
        this.clearForm()
      } catch(e) {
        console.log(e)
      }
    },
    async showEditModal(record) {
      this.title = this.$t('dict.editTitle')
      const { data } = await getDict('zh-CN', record.code)
      const enData = await getDict('en-US', record.code)
      this.dicts = data.content || []
      if (!data.menus) {
        data.menus = []
      }
      this.form = {
        id: data.id,
        code: data.code,
        priority: data.priority,
        enabled: data.enabled,
        details: [
          {
            name: '',
            locale: 'zh-CN'
          },
          {
            name: '',
            locale: 'en-US'
          }
        ],
        content: [],
        'zh-CN': '',
        'en-US': ''
      }
      data.details.forEach(d => {
        this.form[d.locale] = d.name
      })
      if (!this.form['zh-CN']) {
        this.form['zh-CN'] = this.form['en-US']
      }
      this.form.details[0].dictId = data.id
      this.form.details[1].dictId = data.id
      this.form.details[1].name = enData.data.details[0].name
      this.form['en-US'] = enData.data.details[0].name
      enData.data.content.forEach(c => {
        const i = this.dicts.find(d => d.value === c.value)
        console.log(i);
        if (i) {
          i.en = c.text
        }
      })
      this.visible = true
    },
    clearForm() {
      this.form = {
        code: '',
        priority: '',
        enabled: true,
        details: [
          {
            name: '',
            locale: 'zh-CN'
          },
          {
            name: '',
            locale: 'en-US'
          }
        ],
        content: [],
        'zh-CN': '',
        'en-US': ''
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.searchDictList()
    },
    removeContent(record) {
      const index = this.dicts.findIndex(d => d.id === record.id)
      this.dicts.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>
